module.exports = __webpack_public_path__ + "static/media/caution.c482c240.svg";